import React from 'react';
import { TableCell, TableRow, TextField, Autocomplete} from '@mui/material';
import styled from 'styled-components';

const ButtonWrapper =styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`

const SCMeditablerow = ({k, row, page, rowsPerPage, onChangeAssetData, editData,handleCancelClick,tableFontSize, SubmitButton})=>{
    return(
        <>
        <TableRow >
              <TableCell component="th" scope="row" sx={{ fontSize: tableFontSize}}>
                {(page)*(rowsPerPage)+k+1}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row.Category}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                {row.Name}
              </TableCell> 
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                <TextField
                  id="outlined-basic"
                  size='small'
                  type="text"
                  name={'specEdit'}
                  onChange={(e) => onChangeAssetData(e, k)}
                  label="Specification"
                  value={Object.keys(editData.keyValueObject)[0]}
                  variant="outlined"
                  sx={{backgroundColor:"white", width:"200px", height:"40px"}}
                />  
                {/* <input name='specEdit' value={Object.keys(editData.keyValueObject)[0]} onChange={onChangeAssetData}
                ></input> */}
              </TableCell>
              <TableCell  align="left" sx={{ fontSize: tableFontSize}}>
                <TextField
                    id="outlined-basic"
                    size='small'
                    type="text"
                    name={'valueEdit'}
                    onChange={(e) => onChangeAssetData(e, k)}
                    label="Values"
                    value={editData.keyValueObject[Object.keys(editData.keyValueObject)[0]]}
                    variant="outlined"
                    sx={{backgroundColor:"white", width:"200px", height:"40px"}}
                  /> 
              {/* <input name='valueEdit' value={editData.keyValueObject[Object.keys(editData.keyValueObject)[0]]} onChange={onChangeAssetData}
                ></input>             */}
              </TableCell>
              <TableCell align="left" sx={{ fontSize: tableFontSize}}>
                <ButtonWrapper>
                  <SubmitButton type="submit">Save</SubmitButton>
                  <SubmitButton type="button" onClick={(e)=>handleCancelClick(e,k)}>Cancel</SubmitButton>
                </ButtonWrapper>
              </TableCell>
            </TableRow>
        </>
    )
}

export default SCMeditablerow;